
import apiService from "./apiServices";

export const getUser = async (token) => {
  try {
    const response = await apiService('/users/login-user', 'POST', null, null, token);
    return response;
  } catch (error) {
    throw error?.message || 'Get user services failed. Please try again.';
  }
}
export const createUser = async (formData, token) => {
  try {

    const response = await apiService('/users/add-user', 'POST', formData, null, token);
    return response;
  } catch (error) {
    throw error?.message || 'Creating user is failed. Please try again.';
  }
}

export const updateUser = async (formData, token) => {
  try {

    const response = await apiService('/users/update-user', 'PUT', formData, null, token);
    return response;
  } catch (error) {
    throw error?.message || 'Updating user is failed. Please try again.';
  }
}

export const getUserById = async (userId, token) => {
  try {

    const response = await apiService(`/users/userId/${userId}`, 'GET', null, null, token);
    return response;
  } catch (error) {
    throw error?.message || 'service is failed. Please try again.';
  }
}

export const getAllUser = async (customerId, token) => {
  try {

    const response = await apiService(`/users/all-users/customer/${customerId}`, 'GET', null, null, token);
    return response;
  } catch (error) {
    throw error?.message || 'service is failed. Please try again.';
  }
}

export const getRates = async (data, quoteId, token = "") => {
  try {

    const response = await apiService(`/soapConsume/${quoteId}`, 'GET', null, null, token);
    return response;
  } catch (error) {
    throw new Error(error.message || 'Get user services failed. Please try again.');
  }
}
export const postRatesPearl = async (data, company, token) => {
  try {

    const response = await apiService(`/soapConsume/${company}`, 'POST', data, null, token);
    return response;
  } catch (error) {
    throw new Error(error.message || 'Get user services failed. Please try again.');
  }
}

export const postRatesPearlHolding = async (data, quoteId, token) => {
  try {

    const response = await apiService(`/soapConsume/pearl`, 'POST', data, null, token);
    return response;
  } catch (error) {
    throw new Error(error.message || 'Get pearl services failed. Please try again.');
  }
}


export const postRatesUnited = async (data, quoteId, token) => {
  try {

    const response = await apiService(`/soapConsume/united`, 'POST', data, null, token);
    return response;
  } catch (error) {
    throw new Error(error.message || 'Get user services failed. Please try again.');
  }
}

export const getAllRates = async (quoteId, planOptions, term, companyName, token = "") => {
  if (!quoteId || !planOptions || !term || !companyName) {
    throw new Error('Missing required parameters for getting rates');
  }

  try {
    const response = await apiService(
      `/comparison/companies/${quoteId}/${planOptions}/${term}/${companyName}`,
      'GET',
      null,
      null,
      token
    );

    return response;
  } catch (error) {

    const errorResponse = {
      msgStatus: error.response?.data?.msgStatus || 'Error',
      msgDescription: error.response?.data?.msgDescription || error.message || 'An error occurred',
      gpId: error.response?.data?.gpId || null,
      companyName: error.response?.data?.companyName || null,
    };

    throw errorResponse;
  }
}

export const getAllVehicleDetails = async (quoteId,planOptions,term,companyName, token = "") => {
  try {

    const response = await apiService(`/comparison/VehDetails/${quoteId}/${planOptions}/${term}/${companyName}`, 'GET', null, null, token);
    return response;
  } catch (error) {
    throw new Error(error.message || 'Get rates services failed. Please try again.');
  }
}


export const getEFTById = async (gpId,planOptions, term,companyName, token) => {
  try {
    const headers = {
      'Access-Control-Request-Headers': '*'
    };
    const response = await apiService(`/comparison/OtherEFT/${gpId}/${planOptions}/${term}/${companyName}`, 'GET', null, headers, token);
    return response;
  } catch (error) {
    throw new Error(error.message || 'service is failed. Please try again.');
  }
}

export const getInstallment = async (quoteId,planOptions,term,companyName, token = "") => {
  try {

    const response = await apiService(`/comparison/installmentDetails/${quoteId}/${planOptions}/${term}/${companyName}`, 'GET', null, null, token);
    return response;
  } catch (error) {
    throw new Error(error.message || 'Get installment services failed. Please try again.');
  }
}

export const convertQuoteToPolicyService = async (data, token) => {
  try {

    const response = await apiService(`/quotes-to-policy/convert`, 'POST', data, null, token);
    return response;
  } catch (error) {
    throw new Error(error.message || 'Post convert quote to policy services failed. Please try again.');
  }
}

export const getAllDetailsRates = async (quoteId, planOptions, term, companyName, token = "") => {
  if (!quoteId || !planOptions || !term || !companyName) {
    throw new Error('Missing required parameters for getting rates');
  }

  try {
    const response = await apiService(
      `/comparison/GetRatesDetailed/${quoteId}/${planOptions}/${term}/${companyName}`,
      'GET',
      null,
      null,
      token
    );
  if (response.msgStatus === 'Error') {
      // Treat it as an error and throw it
      const errorResponse = {
        msgStatus: response.msgStatus,
        msgDescription: response.msgDescription,
        gpId: response.gpId || null,
        companyName: response.companyName || null,
      };
      throw errorResponse;
    }
    return response;
  } catch (error) {
    if (error.msgStatus) {
      throw error;
    }
    const errorResponse = {
      msgStatus: error.response?.data?.msgStatus || 'Error',
      msgDescription: error.response?.data?.msgDescription || error.message || 'An error occurred',
      gpId: error.response?.data?.gpId || null,
      companyName: error.response?.data?.companyName || null,
    };

    throw errorResponse;
  }
}
export const getUnderwritingMsg = async (quoteId,companyName, token) => {
  try {

    const response = await apiService(`/comparison/UnderWritingMessage/${quoteId}/${companyName}`, 'GET', null, null, token);
    return response;
  } catch (error) {
    throw new Error(error.message || 'Get Underwriting services failed. Please try again.');
  }
}

export const getLogeedInUserDetail = async (token) => {
  try {

    const response = await apiService(`/userprofile/me`, 'GET', null, null, token);
    return response;
  } catch (error) {
    throw error?.message || 'service is failed. Please try again.';
  }
}

export const updateLogeedInUserDetail = async (formData, token) => {
  try {

    const response = await apiService('/userprofile/me', 'PUT', formData, null, token);
    return response;
  } catch (error) {
    throw error?.message || 'Updating user is failed. Please try again.';
  }
}

export const searchAgentServices = async (searchKeyword, token) => {
  try {

    const response = await apiService(`/users/search?query=${searchKeyword}`, 'GET', null, null, token);
    return response;
  } catch (error) {
    throw error?.message || 'Search agent is failed. Please try again.';
  }
}

